import { get, post, patch } from "@services/apiService.js";

export default {
    getSite() {
        return get(`/v4/design-manager/v1/site`, {})
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    getSiteConfig() {
        return get(`/v4/design-manager/v1.2/site`, {})
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    getSiteTheme() {
        return get(`/v4/design-manager/v1.1/metadata/main?version=${process.env.VUE_APP_RENDER_VERSION}`, {})
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    getSiteMetadata({ lang }) {
        return get(`/v4/design-manager/v1.1/metadata/languages/${lang}/site?version=${process.env.VUE_APP_RENDER_VERSION}`, {})
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    getSitePage({ lang, id }) {
        return get(`/v4/design-manager/v1.1/metadata/languages/${lang}/pages/${id}?version=${process.env.VUE_APP_RENDER_VERSION}`, {})
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    getSitePageComponent({ lang, pageID, componentID }) {
        return get(`/v4/design-manager/v1.1/metadata/languages/${lang}/pages/${pageID}/assets/components/${componentID}?version=${process.env.VUE_APP_RENDER_VERSION}`, {})
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    setSite({ data }) {
        return patch(`/v4/design-manager/v1.1/metadata?version=${process.env.VUE_APP_RENDER_VERSION}`, data)
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    publishStatus() {
        return get(`/v4/design-manager/v1/publishes/current/status`)
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    },
    publishSite() {
        return post(`/v4/design-manager/v1/publishes/generate?version=${process.env.VUE_APP_RENDER_VERSION}`)
            .then(response => {
                return response.data || {};
            })
            .catch(error => {
                throw error;
            });
    }
};
